import { render, staticRenderFns } from "./DocumentOrganizationModel.vue?vue&type=template&id=0d13ead1&scoped=true"
import script from "./DocumentOrganizationModel.vue?vue&type=script&lang=js"
export * from "./DocumentOrganizationModel.vue?vue&type=script&lang=js"
import style0 from "./DocumentOrganizationModel.vue?vue&type=style&index=0&id=0d13ead1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d13ead1",
  null
  
)

export default component.exports